export const COLOR_PALETTE = {
  red:    { r: 231, g: 76,  b: 60  },
  blue:   { r: 52,  g: 152, b: 219 },
  green:  { r: 46,  g: 204, b: 113 },
  yellow: { r: 241, g: 196, b: 15  },
  purple: { r: 155, g: 89,  b: 182 },
  orange: { r: 230, g: 126, b: 34  },
  cyan:   { r: 26,  g: 188, b: 156 },
  pink:   { r: 233, g: 30,  b: 140 },
} as const;

export type ColorName = keyof typeof COLOR_PALETTE;

export const COLOR_NAMES = Object.keys(COLOR_PALETTE) as ColorName[];
